import { License } from "../../api/decimal/common-types/manageAssets.ts";
import { useExploreBookAvailable } from "../../../routes/home/common/explore/useExploreBookAvailable.ts";
import CoverBadge from "./CoverBadge.tsx";
import { isExpiringSoon } from "./assetHelpers.ts";
import { useIntl } from "react-intl";
import { useMemo } from "react";
import { StoreData } from "../../api/decimal/methods/searchStore.ts";

export default function DefaultCoverBadge({
  license,
  explore,
  store,
}: {
  license?: License;
  explore?: VST.Bridge.Asset;
  store?: StoreData;
}) {
  const intl = useIntl();
  const exploreAvailable = useExploreBookAvailable(explore);

  const message = useMemo(() => {
    if (explore) {
      // Never show badges on store results
      if (store) {
        return null;
      }
      // If we have an explore book we can't show an action on, it must be unavailable
      if (!exploreAvailable) {
        return intl.formatMessage({ defaultMessage: "Unavailable" });
      }
    }

    // Only show expiring/expired if there are no valid explore actions
    if (license && !exploreAvailable) {
      if (license.expired) {
        return intl.formatMessage({ defaultMessage: "Expired" });
      }
      if (isExpiringSoon(license)) {
        return intl.formatMessage({ defaultMessage: "Expiring Soon" });
      }
    }

    return "";
  }, [explore, license, exploreAvailable, store, intl]);

  if (message) {
    return <CoverBadge>{message}</CoverBadge>;
  }
}
